import { DECIMAL_BASE } from '@Admin/AdminUserQuotesPage/constants'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { THREADS_KEY } from '@Builder/QuoteDetailPage/FilesTab/ConfigurationModal/constants'

import { Params } from '~/apps/consumer/components/PartViewerModal/types'
import { getUserIdentity } from '~/redux-modules/identity'
import {
    PART_DETAILS_PAGES,
    DFM_FEEDBACK_KEY,
    TRACK_SHIPMENT_KEY,
    INSPECTION_KEY,
    SUMMARY_KEY,
} from '~/apps/consumer/components/PartViewerModal/logic'

export function useGetOboDetails(quoteUserId: string | number) {
    const { userId } = useParams<Params>()

    return useSelector(state => {
        const identity = getUserIdentity(state)
        const { id: loggedInUserId, isAdmin } = identity

        return {
            isObo: userId && isAdmin && loggedInUserId !== quoteUserId,
            oboUserId: parseInt(userId || '', DECIMAL_BASE),
        }
    })
}

export function getHeaderTitle(pageTitle: string | null) {
    switch (pageTitle) {
        case SUMMARY_KEY:
            return PART_DETAILS_PAGES.SUMMARY
        case DFM_FEEDBACK_KEY:
            return PART_DETAILS_PAGES.MANUFACTURING_FEEDBACK
        case TRACK_SHIPMENT_KEY:
            return PART_DETAILS_PAGES.TRACK_SHIPMENT
        case INSPECTION_KEY:
            return PART_DETAILS_PAGES.INSPECTION_REPORT
        case THREADS_KEY:
            return PART_DETAILS_PAGES.THREADS
        default:
            return pageTitle
    }
}
